<div class="wrapper">
    <div class="content">
      <ng-content></ng-content>
    </div>
    <div class="bar" (resizable)="onResize($event)"></div>
  </div>
  